import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export const AsyncReportDescriptionTooltip = Loadable({
  loader: () => import(
  // name this a consistent chunk name for now
  /* webpackChunkName: "SingleReportViewerModalContainer" */
  './ReportDescription').then(module => module.ReportDescriptionTooltip),
  LoadingComponent: () => null
});